import ConfirmOtpComponent from './ConfirmOtpContainer';

export default ConfirmOtpComponent;